'use strict';

intellidealerAppCoreModule.factory('newsResource', function ($resource, appConfigurationService) {
  return {
    dealershipNewsList: $resource(appConfigurationService.basePath + '/rest/news/dealershipNewsList/'),
    dealershipNewsImageByTimestamp: $resource(appConfigurationService.basePath + '/rest/news/dealershipNewsImageByTimestamp/')
  }
});
